import { lockBody, unlockBody } from '../utils/bodyLock';
const toggleModal = (modalID) => {
    const element = document.getElementById(modalID);
    if (element) {
        if (!element.classList.contains('hide-modal')) {
            // hide modal
            if (element.classList.contains('show-modal')) {
                element.classList.remove('show-modal');
            }
            element.classList.add('fade-out-modal');
            unlockBody();
            setTimeout(() => {
                element.classList.add('hide-modal');
            }, 320);
        }
        else {
            // show modal
            element.classList.remove('hide-modal');
            element.classList.remove('fade-out-modal');
            element.classList.add('show-modal');
            lockBody();
        }
    }
};
export const closeModal = (modalID) => {
    const modalElem = document.querySelector(`.modal#${modalID}`);
    if (modalElem) {
        toggleModal(modalID);
    }
};
const initModal = (modalID, options) => {
    const modalElem = document.querySelector(`.modal#${modalID}`);
    if (modalElem) {
        const cancelButtons = modalElem.querySelectorAll('[data-modal-close]');
        cancelButtons.forEach((button) => {
            if (button.getAttribute('data-enabled') !== 'true') {
                button.setAttribute('data-enabled', 'true');
                button.addEventListener('click', () => {
                    if (options && (options === null || options === void 0 ? void 0 : options.onClose) && typeof options.onClose === 'function') {
                        options.onClose();
                    }
                    closeModal(modalID);
                });
            }
        });
    }
};
export { toggleModal, initModal };
